// extracted by mini-css-extract-plugin
export default {"container":"dcc_sidebar-container","sidebarClosed":"dcc_sidebar-sidebarClosed","toggleButton":"dcc_sidebar-toggleButton"};